import { DialogMessageComponent } from './dialog-message/dialog-message.component';
import { SystemMessageComponent } from './system-message/system-message.component';

export interface ComponentManifestType {
  componentId: string;
  loader?;
  component?;
}

const STATIC_MANIFESTS: ComponentManifestType[] = [
  {
    componentId: 'DialogMessageComponent',
    component: DialogMessageComponent,
  },
  {
    componentId: 'SystemMessageComponent',
    component: SystemMessageComponent,
  },
];

const LAZY_LOAD_MANIFESTS: ComponentManifestType[] = [
  {
    componentId: 'PostEscalationMenuComponent',
    loader: () =>
      import('./post-escalation-menu/post-escalation-menu.component').then(
        (m) => m.PostEscalationMenuComponent
      ),
  },
  {
    componentId: 'StatusSummaryComponent',
    loader: () =>
      import('./status-summary/status-summary.component').then(
        (m) => m.StatusSummaryComponent
      ),
  },
  {
    componentId: 'StatusDetailsOverlayComponent',
    loader: () =>
      import('./status-details-overlay/status-details-overlay.component').then(
        (m) => m.StatusDetailsOverlayComponent
      ),
  },
  {
    componentId: 'SafeSendBubbleComponent',
    loader: () =>
      import('./safe-send-bubble/safe-send-bubble.component').then(
        (m) => m.SafeSendBubbleComponent
      ),
  },
  {
    componentId: 'OverlayComponent',
    loader: () =>
      import('./overlay/overlay.component').then((m) => m.OverlayComponent),
  },
  {
    componentId: 'EmailTranscriptComponent',
    loader: () =>
      import('./email-transcript/email-transcript.component').then(
        (m) => m.EmailTranscriptComponent
      ),
  },
  {
    componentId: 'PaymentOverlayComponent',
    loader: () =>
      import('./payment-overlay/payment-overlay.component').then(
        (m) => m.PaymentOverlayComponent
      ),
  },
  {
    componentId: 'IframeOverlayComponent',
    loader: () =>
      import('./iframe-overlay/iframe-overlay.component').then(
        (m) => m.IframeOverlayComponent
      ),
  },
  {
    componentId: 'AlertComponent',
    loader: () =>
      import('@rogers/cdk/assembled/alert').then((m) => m.AlertComponent),
  },
  {
    componentId: 'BurialStatusCardComponent',
    loader: () =>
      import('./burial-status-card/burial-status-card.component').then(
        (m) => m.BurialStatusCardComponent
      ),
  },
];

export const COMPONENT_MANIFESTS: ComponentManifestType[] = [
  ...STATIC_MANIFESTS,
  ...LAZY_LOAD_MANIFESTS,
];
